module.exports = __webpack_public_path__ + "img/default_live_stream_thumbnail.cb4844a9.jpg";